namespace GeniuzPOS.Administration {
    export class SysParaColumns {
        static columnsKey = 'Administration.SysPara';
    }
}
